import React, { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppState, Auth0Provider } from '@auth0/auth0-react'
import config from '../config/config'

export default function Auth0ProviderWithHistory({
  children,
}: {
  children: ReactNode
}) {
  const navigate = useNavigate()
  const onRedirectCallback = (appState?: AppState) =>
    navigate(appState?.returnTo || window.location.pathname)

  return (
    <Auth0Provider
      domain={config.auth.domain}
      clientId={config.auth.clientId}
      redirectUri={window.location.origin + process.env.PUBLIC_URL}
      audience={config.auth.serverApiId}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}
